import React from 'react';
import * as Sentry from '@sentry/react';

import ServerError from '../../containers/ServerError';
import { __DEBUG__ } from '../../config/constants';

import './style.scss';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.log('Exception caught. Error:', error);
    console.log('Exception caught. Info:', info);

    if (!__DEBUG__) {
      Sentry.captureException(error);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ServerError />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
